const technologyAttributesContainsOv = (technologyAttributes) => {
    return _.find(technologyAttributes, attribute => {
        return attribute.id === 'ovfwefwefwe'
    })
}

export default technologyAttributesContainsOv